import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IDuplicateVenueCategoryRequestBody, IDuplicateVenueCategoryResponseData } from './types';

const FALLBACK_MESSAGE = 'Could not duplicate venue category';

const getErrorMessage = async (response: Response): Promise<string> => {
  try {
    const json = await response.json();
    return typeof json?.message === 'string' ? json.message : FALLBACK_MESSAGE;
  } catch {
    return FALLBACK_MESSAGE;
  }
};

export const duplicateVenueCategory = async (
  categoryId: string,
  requestBody: IDuplicateVenueCategoryRequestBody,
): Promise<IDuplicateVenueCategoryResponseData> => {
  const response = await fetch(`${API_URL}/venues/categories/${categoryId}/duplicate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  });

  if (response.status !== Status.CREATED) {
    throw new Error(await getErrorMessage(response));
  }

  const json = await response.json();
  return json.data;
};
